import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { DragAndDropHandler } from "../../utils/DragAndDropHandler";
import { getAllBrandsFromVnAppZone } from "../../utils/BrandHelper";
import { filterArticle_template } from "./filterArticle_template";
declare var ko: any;

export class articleRecommendations_template extends vnTemplate {

    private editingArticleIndex: number = null;
    protected parent: any;

    protected getTemplateHtml(): string {
        return `
            <div class="w-form-body recommended" data-bind="visible: isRecommendedSectionVisible">
                <div class="form-body">
                    <div class="form-section">
                        <strong class="form-sub-title">More from our brands</strong>

                        <div class="w-pinned form-group" data-bind="foreach: { data: recommendedArticles, as: 'article' }, childrenComplete: handleDragAndDrop($element, recommendedArticles, '.article-pinned')">

                            <!-- Edit Mode -->
                            <div class="pinned-form article-pinned entry is-edit" 
                                 data-bind="visible: article.isEditing() && article.isActive()">
                                
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: article.position"></span>
                                </div>

                                <div class="w-btn">
                                    <button class="btn border only-icon icon border i-delete" type="button"
                                            data-bind="event: { click: $parent.onClickDeleteArticle.bind($parent, $index()) }">
                                        <span class="hidden-text">Delete</span>
                                    </button>
                                </div>

                                <div class="w-title" style="display: none">
                                    <span class="w-full-icon full-icon" style="margin-right: 0.5rem;" data-bind="css: 'i-' + (article.brandShortName() || '') + ((['GR','AP','CBR','CB','FLW','HG','HC','HTG','MM','SR','TR','TS','TV','FX'].includes(article.brandShortName())) ? ' dark' : '')"></span>
                                    <span class="pinned-title" data-bind="text: article.title"></span>
                                </div>

                                <div class="last brand selected">
                                    <div>
                                        <label class="form-label">Brand</label>
                                        <select data-bind="value: article.idBrand, 
                                                          options: $parent.getFilteredBrands(),
                                                          optionsText: 'name', 
                                                          optionsValue: 'id',
                                                          disable: $parent.isGlobalLockEnabled() || $parent.isPublishingControl()">
                                        </select>
                                    </div>
                                    <div style="display: flex; align-items: center; gap: 8px;">
                                        <label class="form-label">Article</label>
                                        <div>
                                            <span data-bind="text: article.title()"></span>
                                            <button class="btn btn-form" type="button"
                                                                    data-bind="event: { click: $parent.onClickEditArticleOpenPicker.bind($parent, $index()) },
                                                               disable: $parent.isGlobalLockEnabled() || $parent.isPublishingControl()">
                                                Select Article
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- View Mode -->
                            <div class="pinned-form article-pinned entry" 
                                 data-bind="visible: !article.isEditing() && article.isActive()">
                                
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: article.position"></span>
                                </div>

                                <div class="w-btn">
                                    <button class="btn border only-icon icon border i-delete" type="button"
                                            data-bind="event: { click: $parent.onClickDisableArticle.bind($parent, $index()) },
                                                      disable: $parent.isGlobalLockEnabled() || $parent.isPublishingControl()">
                                        <span class="hidden-text">Delete</span>
                                    </button>
                                </div>

                                <div class="w-title">
                                    <span class="w-full-icon full-icon" style="margin-right: 0.5rem;" data-bind="css: 'i-' + (article.brandShortName() || '') + ((['GR','AP','CBR','CB','FLW','HG','HC','HTG','MM','SR','TR','TS','TV','FX'].includes(article.brandShortName())) ? ' dark' : '')"></span>
                                    <span class="pinned-title" data-bind="text: article.title"></span>
                                </div>

                                <div class="last" style="display: none;">
                                    <label class="form-label"></label>
                                </div>
                            </div>

                        </div>
                        <div class="form-group w-justify">
                            <div class="w-right">
                                <button class="btn-form icon i-plus" type="button" 
                                    data-bind="event: { click: onClickAddArticle }, 
                                               disable: isGlobalLockEnabled() || isPublishingControl()">
                                    Add Article
                                </button>
                            </div>
                        </div>                        

                    </div>
                </div>
            </div>
            
            <style>
                .article-pinned.before {
                    border-top: 2px solid #007bff;
                    margin-top: -2px;
                }
                .article-pinned.after {
                    border-bottom: 2px solid #007bff;
                    margin-bottom: -2px;
                }
                .article-pinned.active {
                    opacity: 0.5;
                }
            </style>
        `;
    }

    public buildViewModel() {
        let self = this;

        return {
            isRecommendedSectionVisible: ko.observable(true),
            recommendedArticles: ko.observableArray([]),
            isPublishingControl: ko.observable(false),
            isGlobalLockEnabled: ko.observable(false),
            allBrands: ko.observableArray([]),
            currentBrandId: ko.observable(null), // Add this


            onClickAddArticle: function (data, event) {
                self.onClickAddArticle();
            },
            onClickEditArticle: function (index, data, event) {
                self.onClickEditArticle(index);
            },
            onClickDeleteArticle: function (index, data, event) {
                self.onClickDeleteArticle(index);
            },
            onClickDisableArticle: function (index, data, event) {
                self.onClickDisableArticle(index);
            },
            onClickEditArticleOpenPicker: function (index, data, event) {
                self.onClickEditArticleOpenPicker(index);
            },
            handleDragAndDrop: function (element, observableArray, selector) {
                return self.handleDragAndDrop(element, observableArray, selector);
            },
            getFilteredBrands: function() {
            return self.getTemplateViewModel().allBrands().filter(function(brand) {
                return brand.id !== self.getTemplateViewModel().currentBrandId();
            });
        },
        };
    }

    protected initPartial(): void {
        this.getTemplateViewModel().allBrands(getAllBrandsFromVnAppZone(this.caller.getVnAppZone()));
        this.getTemplateViewModel().currentBrandId(this.caller.getIdBrand());
    }

    protected onClickAddArticle(): void {
        let articles = this.getTemplateViewModel().recommendedArticles();

        let newArticle = {
            idRecommendedArticle: ko.observable(null),
            idBrand: ko.observable(null),
            brandShortName: ko.observable(""),
            title: ko.observable(""),
            idContentType: ko.observable(null),
            imageBlock: ko.observable(null),
            publishDate: ko.observable(null),
            position: ko.observable(articles.length + 1),
            isEditing: ko.observable(true),
            wasChanged: ko.observable(true),
            isActive: ko.observable(true),
            permalink: ko.observable(""),
            recommendedArticleReference: ko.observable(null),
        };

        articles.push(newArticle);
        this.getTemplateViewModel().recommendedArticles([]);
        this.getTemplateViewModel().recommendedArticles(articles);

        this.editingArticleIndex = articles.length - 1;
    }

    protected onClickEditArticle(index: number): void {
        // Close any currently editing article
        if (this.editingArticleIndex !== null && this.editingArticleIndex !== index) {
            let articles = this.getTemplateViewModel().recommendedArticles();
            articles[this.editingArticleIndex].isEditing(false);
        }

        let articles = this.getTemplateViewModel().recommendedArticles();
        articles[index].isEditing(true);
        this.editingArticleIndex = index;


        this.getTemplateViewModel().recommendedArticles([]);
        this.getTemplateViewModel().recommendedArticles(articles);
    }

    protected onClickDeleteArticle(index: number): void {
        if (confirm("Are you sure you want to remove this recommended article?")) {
            let articles = this.getTemplateViewModel().recommendedArticles();
            articles.splice(index, 1);

            // Reorder positions
            let positionCount = 0;
            for (let i = 0; i < articles.length; i++) {
                if (articles[i].isActive()) {
                    positionCount = positionCount + 1;
                    articles[i].position(positionCount);
                }
                articles[i].wasChanged(true);
            }

            this.getTemplateViewModel().recommendedArticles([]);
            this.getTemplateViewModel().recommendedArticles(articles);

            if (this.editingArticleIndex === index) {
                this.editingArticleIndex = null;
            } else if (this.editingArticleIndex > index) {
                this.editingArticleIndex--;
            }
        }
    }

    protected onClickDisableArticle(index: number): void {
        if (confirm("Are you sure you want to remove this recommended article?")) {
            let articles = this.getTemplateViewModel().recommendedArticles();
            articles[index].isActive(false);
            articles[index].position(-1);

            // Reorder positions
            let positionCount = 0;
            for (let i = 0; i < articles.length; i++) {
                if (articles[i].isActive()) {
                    positionCount = positionCount + 1;
                    articles[i].position(positionCount);
                }
                articles[i].wasChanged(true);
            }

            this.getTemplateViewModel().recommendedArticles([]);
            this.getTemplateViewModel().recommendedArticles(articles);

            if (this.editingArticleIndex === index) {
                this.editingArticleIndex = null;
            } else if (this.editingArticleIndex > index) {
                this.editingArticleIndex--;
            }
        }
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);

        // After drag & drop, update positions
        let articles = currentObservableArray();
        let positionCount = 0;
        for (let i = 0; i < articles.length; i++) {
            if (articles[i].isActive()) {
                positionCount = positionCount + 1;
                if(articles[i].position() != positionCount) {
                    articles[i].wasChanged(true);
                }
                articles[i].position(positionCount);
            }
            articles[i].wasChanged(true);
        }

        // Update editing index if needed
        if (this.editingArticleIndex !== null) {
            let articles = currentObservableArray();
            for (let i = 0; i < articles.length; i++) {
                if (articles[i].isEditing()) {
                    this.editingArticleIndex = i;
                    break;
                }
            }
        }
    }

    // Public API Methods

    public getRecommendedArticles(): any[] {
        return this.getTemplateViewModel().recommendedArticles();
    }

    public setRecommendedArticles(articles: any[]): void {
        let allBrands = this.getTemplateViewModel().allBrands();
        let observableArticles = articles.map(function (article, index) {
            const result = allBrands.find(item => item.id === article.idBrand);
            const shortName = result ? result.shortName : null;
            return {
                idRecommendedArticle: ko.observable(article.idRecommendedArticle),
                idBrand: ko.observable(article.idBrand),
                brandShortName: ko.observable(shortName),
                title: ko.observable(article.title),
                idContentType: ko.observable(article.idContentType),
                imageBlock: ko.observable(article.imageBlock),
                publishDate: ko.observable(article.publishDate),
                position: ko.observable(article.position || index + 1),
                isEditing: ko.observable(false),
                permalink: ko.observable(article.permalink),
                recommendedArticleReference: ko.observable(article.recommendedArticleReference),
                wasChanged: ko.observable(false),
                isActive: ko.observable(article.isActive)
            };
        });

        this.getTemplateViewModel().recommendedArticles(observableArticles);
    }

    public setIsPublishingControl(value: boolean): void {
        this.getTemplateViewModel().isPublishingControl(value);
    }

    public setIsGlobalLockEnabled(value: boolean): void {
        this.getTemplateViewModel().isGlobalLockEnabled(value);
    }

    public getSerializedData(): any[] {
        let articles = this.getTemplateViewModel().recommendedArticles();
        let positionCount = 0;
        let articlesExcludingEdits = articles.filter(function (article) {
            return !article.isEditing();
        })
        return articlesExcludingEdits.map(function (article, index) {
            if(article.isActive()) {
                positionCount = positionCount + 1;
            }
            return {
                idRecommendedArticle: article.idRecommendedArticle(),
                idBrand: article.idBrand(),
                title: article.title(),
                idContentType: article.idContentType(),
                imageBlock: article.imageBlock(),
                publishDate: article.publishDate(),
                position: article.isActive() ? positionCount : -1,
                permalink: article.permalink(),
                recommendedArticleReference: article.recommendedArticleReference(),
                wasChanged: article.wasChanged(),
                isActive: article.isActive()
            };
        });
    }

    public clearAll(): void {
        this.getTemplateViewModel().recommendedArticles([]);
        this.editingArticleIndex = null;
    }

    public getHtmlBuild(): string {
        let div = document.createElement('div');
        div.appendChild(this.build());
        return div.innerHTML;
    }

    protected getTemplateName(): string {
        return "articleRecommendations_template";
    }

    public setParent(parent) {
        this.parent = parent;
    }

    protected onClickEditArticleOpenPicker(index: number): void {
        let articles = this.getTemplateViewModel().recommendedArticles();
        let article = articles[index];

        this.parent.articlePicker.showArticlePickerForExternalRecommendations(article.idBrand(), article.brandShortName(), index);
    }

    public updateArticleRecommendationAtIndex(index, article) {
        let articles = this.getTemplateViewModel().recommendedArticles();
        let existingArticle = articles[index];
        let fullUrl = "https://" + article.brand.domain + article.permalink;
        articles[index] = {
            idRecommendedArticle: ko.observable(article.id),
            idBrand: ko.observable(article.brand.id),
            brandShortName: ko.observable(article.brand.shortName),
            title: ko.observable(article.title),
            idContentType: ko.observable(article.contentType.id),
            imageBlock: ko.observable(article.featuredImage),
            publishDate: ko.observable(article.dateCreated),
            position: ko.observable(existingArticle.position()),
            isEditing: ko.observable(false),
            permalink: ko.observable(fullUrl),
            recommendedArticleReference: ko.observable(article.reference),
            wasChanged: ko.observable(true),
            isActive: ko.observable(true)
        };
        this.getTemplateViewModel().recommendedArticles([]);
        this.getTemplateViewModel().recommendedArticles(articles);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/articleRecommendations_template.ts